import { cn } from "@/lib/utils";

type Tone = "dark" | "light" | "current";

interface BrandWordmarkProps {
  /** Visual tone — "dark" for light backgrounds, "light" for dark backgrounds, "current" inherits currentColor */
  tone?: Tone;
  /** Tailwind height class, e.g. "h-8" — width is auto via viewBox */
  className?: string;
  /** Accessible label (kept off-screen for SEO; an aria-label is set on svg) */
  title?: string;
}

/**
 * Hijabi Store wordmark — Brand Board v1.0
 * "Hijabi" in Fraunces 500, "Store" in Fraunces 300 at 55% opacity.
 * Renders as inline SVG so it scales crisply and respects color tokens.
 */
export const BrandWordmark = ({
  tone = "dark",
  className,
  title = "Hijabi Store",
}: BrandWordmarkProps) => {
  const fill =
    tone === "current"
      ? "currentColor"
      : tone === "light"
        ? "hsl(var(--cream))"
        : "hsl(var(--charcoal))";

  return (
    <svg
      viewBox="0 0 760 180"
      role="img"
      aria-label={title}
      className={cn("w-auto", className)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="0"
        y="135"
        fontFamily="'Fraunces', Georgia, 'Times New Roman', serif"
        fontWeight={500}
        fontSize="160"
        letterSpacing="-5"
        fill={fill}
        style={{ fontVariationSettings: '"opsz" 144, "SOFT" 30' }}
      >
        Hijabi
        <tspan fontWeight={300} fill={fill} opacity={0.55}>
          Store
        </tspan>
      </text>
    </svg>
  );
};

export default BrandWordmark;
